import APIConfiguration from '@savgroup-front-common/configuration/api';
import {
  COMMON_QUERY_PARAMS,
  CURRENCIES,
} from '@savgroup-front-common/constants';
import { SUPPORTED_METHODS } from '@savgroup-front-common/constants/shared/supportedMethods';
import {
  buildUrl,
  prepareResponseFailure,
} from '@savgroup-front-common/core/helpers';
import {
  ApiRequestDescriptor,
  executeQuery,
} from '@savgroup-front-common/core/services';
import {
  BackResponse,
  BackResponseFailure,
} from '@savgroup-front-common/types';

const ENDPOINT = `${APIConfiguration.repairer}files/${COMMON_QUERY_PARAMS.FILE_ID}/quotes/withmargin`;

export interface GetQuoteInfoByFileIdQueryArgs {
  fileId: string;
}

interface GetQuoteInfoByFileIdQueryReturnValue {
  amountVAT: number;
  amountWithoutVAT: number;
  author: {
    userId: string;
    externalId: string;
    fullname: string;
  };
  comments: string;
  createdDate: Date;
  currencyCode: CURRENCIES;
  editedDate: Date;
  fileId: string;
  id: string;
  quoteItemSummaries: {
    bundlePrice: number;
    id: string;
    laborPrice: number;
    name: string;
  }[];
  state: string;
  valueAddedTaxRate: number;
}

export const getQuoteInfoByFileIdRequest = (
  payload: GetQuoteInfoByFileIdQueryArgs,
): ApiRequestDescriptor => ({
  url: buildUrl(ENDPOINT.replace(COMMON_QUERY_PARAMS.FILE_ID, payload.fileId)),
  config: { method: SUPPORTED_METHODS.GET },
});

async function getQuoteInfoByFileIdQuery(
  payload: GetQuoteInfoByFileIdQueryArgs,
): Promise<
  BackResponse<GetQuoteInfoByFileIdQueryReturnValue[]> | BackResponseFailure
> {
  try {
    return await executeQuery<
      BackResponse<GetQuoteInfoByFileIdQueryReturnValue[]>
    >(getQuoteInfoByFileIdRequest(payload));
  } catch (error) {
    return prepareResponseFailure(error);
  }
}

export default getQuoteInfoByFileIdQuery;
